import axios from "axios";
import router from "@/router";
import msg from "@/assets/js/msg.js";
import Vue from "vue";
import md5 from "../assets/js/md5";
import baseUrl from './baseUrl.js'

// 环境的切换
if (process.env.NODE_ENV === "development") {
  // axios.defaults.baseURL = "https://hkjy-api.hikoon.com/index"; //线上
  axios.defaults.baseURL = baseUrl + "/index"; //线上
} else if (process.env.NODE_ENV === "debug") {
  axios.defaults.baseURL = "";
} else if (process.env.NODE_ENV === "production") {
  axios.defaults.baseURL = baseUrl + "/index";
}
axios.defaults.timeout = 10000;
import store from "../store";

axios.defaults.headers.post["Content-Type"] = "multipart/form-data";

// // 请求拦截器
axios.interceptors.request.use(
  (config) => {
    Vue.prototype.$Loading.show("loading");
    if (config.params) {
      if (!config.params.show) {
        Vue.prototype.$Loading.show("loading");
      } else {
        Vue.prototype.$Loading.hide();
      }
    }
    // 记录试听音乐
    if (config.url == "/auditionSong") {
      Vue.prototype.$Loading.hide();
    }
    if (store.state.user.token) {
      config.headers.token = store.state.user.token;
    }
    var timestamp = Date.parse(new Date());
    let time = timestamp.toString().substring(0, 10);
    config.headers.timestamp = time;

    config.headers.sign = md5(time + "sha1");
    return config;
  },
  (error) => {
    Vue.prototype.$Loading.hide();
    return Promise.error(error);
  }
);

// // 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      Vue.prototype.$Loading.hide();
      // 登录过期
      if (response.data.code == 401) {
        store.commit("setUser", {});
        store.commit("setDialogVisible", true);
      }
      //--新增该用户已被禁用--跳转无权限页面
      if (response.data.code == 403) {
        store.commit("setUser", {});
        store.commit("updateShowSysType", 1);
        store.commit("updateShowSys", true);
      }
      //--新增该用户已被删除--跳转无权限页面
      if (response.data.code == 404) {
        store.commit("setUser", {});
        store.commit("updateShowSysType", 2);
        store.commit("updateShowSys", true);
      }
      return Promise.resolve(response);
    } else {
      Vue.prototype.$Loading.hide();
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    Vue.prototype.$Loading.hide();
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          msg("error", "提示", "请先登录后操作");
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          msg("error", "提示", "登录过期，请重新登录");

          // 清除token
          localStorage.removeItem("token");
          setTimeout(() => {
            router.push({
              path: "/login",
              query: {
                redirect: router.currentRoute.fullPath,
              },
            });
          }, 1000);
          break;
        // 404请求不存在
        case 404:
          msg("error", "提示", "网络请求不存在");
          break;
        // 其他错误，直接抛出错误提示
        default:
          msg("error", "提示", "网络错误");
      }

      return Promise.reject(error);
    }
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params })
      .then((res) => {

        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {

  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => {

        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
